import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { Layout, Menu, Button, Tag } from 'antd';
import {
  UserOutlined,
  CalendarOutlined,
  DollarOutlined,
  FileTextOutlined,
  LogoutOutlined,
  TeamOutlined,
  HistoryOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  CreditCardOutlined,
  EnvironmentOutlined,
  InfoCircleOutlined,
  ClockCircleOutlined,
  EditOutlined,
  ShoppingOutlined,
} from '@ant-design/icons';
import UserManagement from './pages/UserManagement';
import AttendanceManagement from './pages/AttendanceManagement';
import AttendanceByDate from './pages/AttendanceByDate';
import TemporaryUserPayments from './pages/TemporaryUserPayments';
import AdvanceManagement from './pages/AdvanceManagement';
import AdvanceReport from './pages/AdvanceReport';
import SalarySlipManagement from './pages/SalarySlipManagement';
import UserSalarySlips from './pages/UserSalarySlips';
import SalaryPayment from './pages/SalaryPayment';
import SiteManagement from './pages/SiteManagement';
import InventoryManagement from './pages/InventoryManagement';
import VersionManagement from './pages/VersionManagement';
import Whiteboard from './pages/Whiteboard';
import LoginPage from './pages/LoginPage';
import AdminManagement from './pages/AdminManagement';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import AccountDeletionRequestPage from './pages/AccountDeletionRequestPage';
import RoleProtectedRoute from './components/RoleProtectedRoute';
import ThemeSelector from './components/ThemeSelector';
import { useRoleAccess } from './hooks/useRoleAccess';
import authService from './services/authService';
import { themeConfig } from './config/theme';
import logo from './assets/logo.png';
import './App.css';

const { Header, Content, Sider } = Layout;

// Wrapper component to use the role access hook
const MainApp = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { userRole, canAccessPage, getRoleColor } = useRoleAccess();
  const user = authService.getCurrentUser();

  const handleLogout = () => {
    authService.logout();
    window.location.href = '/login';
  };

  console.log(user);
  if (!user) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/request-account-deletion" element={<AccountDeletionRequestPage />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider
          breakpoint="lg"
          collapsedWidth="0"
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          trigger={null}
        >
          <div className="logo" style={{ padding: '16px', textAlign: 'center', backgroundColor: themeConfig.background.white }}>
            <img src={logo} alt="Devaram Interiors Logo" style={{ width: '100%' }} />
          </div>
          <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
            {canAccessPage('user-management') && (
              <Menu.Item key="1" icon={<UserOutlined />}>
                <Link to="/users">Worker Management</Link>
              </Menu.Item>
            )}
            {canAccessPage('admin-management') && (
              <Menu.Item key="5" icon={<TeamOutlined />}>
                <Link to="/admins">Admin Management</Link>
              </Menu.Item>
            )}
            {canAccessPage('attendance-management') && (
              <Menu.Item key="2" icon={<CalendarOutlined />}>
                <Link to="/attendance">Attendance</Link>
              </Menu.Item>
            )}
            {canAccessPage('attendance-management') && (
              <Menu.Item key="10" icon={<ClockCircleOutlined />}>
                <Link to="/attendance-by-date">Attendance by Date</Link>
              </Menu.Item>
            )}
            {canAccessPage('attendance-management') && (
              <Menu.Item key="14" icon={<DollarOutlined />}>
                <Link to="/temporary-user-payments">Temp User Payments</Link>
              </Menu.Item>
            )}
            {canAccessPage('advance-management') && (
              <Menu.Item key="3" icon={<DollarOutlined />}>
                <Link to="/advances">Advance</Link>
              </Menu.Item>
            )}
            {canAccessPage('advance-management') && (
              <Menu.Item key="11" icon={<FileTextOutlined />}>
                <Link to="/advance-report">Advance Report</Link>
              </Menu.Item>
            )}
            {canAccessPage('salary-slip-management') && (
              <Menu.Item key="4" icon={<FileTextOutlined />}>
                <Link to="/salary-slips">Salary Slip</Link>
              </Menu.Item>
            )}
            {canAccessPage('salary-payment') && (
              <Menu.Item key="7" icon={<CreditCardOutlined />}>
                <Link to="/salary-payment">Salary Payment</Link>
              </Menu.Item>
            )}
            {canAccessPage('salary-slip-management') && (
              <Menu.Item key="6" icon={<HistoryOutlined />}>
                <Link to="/user-salary-slips">User Slip History</Link>
              </Menu.Item>
            )}
            {canAccessPage('site-management') && (
              <Menu.Item key="8" icon={<EnvironmentOutlined />}>
                <Link to="/site-management">Site Management</Link>
              </Menu.Item>
            )}
            {(canAccessPage('user-management') || canAccessPage('site-management')) && (
              <Menu.Item key="13" icon={<ShoppingOutlined />}>
                <Link to="/inventory-management">Inventory Management</Link>
              </Menu.Item>
            )}
            {canAccessPage('version-management') && (
              <Menu.Item key="9" icon={<InfoCircleOutlined />}>
                <Link to="/version-management">Version Management</Link>
              </Menu.Item>
            )}
            {canAccessPage('whiteboard') && (
              <Menu.Item key="12" icon={<EditOutlined />}>
                <Link to="/whiteboard">Whiteboard</Link>
              </Menu.Item>
            )}
          </Menu>
        </Sider>
        <Layout className="site-layout">
          <Header className="site-layout-background" style={{ padding: '0 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{ color: '#ffffff' }}
            />
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <span style={{ color: '#ffffff', fontSize: '16px', fontWeight: '500' }}>
                Welcome, {user.user.FullName || 'Admin'}
              </span>
              {userRole && (
                <Tag color={getRoleColor(userRole)} style={{ margin: 0 }}>
                  {userRole}
                </Tag>
              )}
              <ThemeSelector />
              <Button type="primary" icon={<LogoutOutlined />} onClick={handleLogout}>
                Logout
              </Button>
            </div>
          </Header>
          <Content style={{ margin: '0 16px' }}>
            <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
              <Routes>
                <Route path="/" element={
                  <RoleProtectedRoute pageName="user-management" fallback={<Navigate to="/version-management" />}>
                    <Navigate to="/users" />
                  </RoleProtectedRoute>
                } />
                <Route path="/dashboard" element={
                  <RoleProtectedRoute pageName="user-management" fallback={<Navigate to="/version-management" />}>
                    <Navigate to="/users" />
                  </RoleProtectedRoute>
                } />
                <Route path="/users" element={
                  <RoleProtectedRoute pageName="user-management">
                    <UserManagement />
                  </RoleProtectedRoute>
                } />
                <Route path="/admins" element={
                  <RoleProtectedRoute pageName="admin-management">
                    <AdminManagement />
                  </RoleProtectedRoute>
                } />
                <Route path="/attendance" element={
                  <RoleProtectedRoute pageName="attendance-management">
                    <AttendanceManagement />
                  </RoleProtectedRoute>
                } />
                <Route path="/attendance-by-date" element={
                  <RoleProtectedRoute pageName="attendance-management">
                    <AttendanceByDate />
                  </RoleProtectedRoute>
                } />
                <Route path="/temporary-user-payments" element={
                  <RoleProtectedRoute pageName="attendance-management">
                    <TemporaryUserPayments />
                  </RoleProtectedRoute>
                } />
                <Route path="/advances" element={
                  <RoleProtectedRoute pageName="advance-management">
                    <AdvanceManagement />
                  </RoleProtectedRoute>
                } />
                <Route path="/advance-report" element={
                  <RoleProtectedRoute pageName="advance-management">
                    <AdvanceReport />
                  </RoleProtectedRoute>
                } />
                <Route path="/salary-slips" element={
                  <RoleProtectedRoute pageName="salary-slip-management">
                    <SalarySlipManagement />
                  </RoleProtectedRoute>
                } />
                <Route path="/salary-payment" element={
                  <RoleProtectedRoute pageName="salary-payment">
                    <SalaryPayment />
                  </RoleProtectedRoute>
                } />
                <Route path="/user-salary-slips" element={
                  <RoleProtectedRoute pageName="salary-slip-management">
                    <UserSalarySlips />
                  </RoleProtectedRoute>
                } />
                <Route path="/site-management" element={
                  <RoleProtectedRoute pageName="site-management">
                    <SiteManagement />
                  </RoleProtectedRoute>
                } />
                <Route path="/inventory-management" element={
                  <RoleProtectedRoute pageName="user-management">
                    <InventoryManagement />
                  </RoleProtectedRoute>
                } />
                <Route path="/version-management" element={
                  <RoleProtectedRoute pageName="version-management">
                    <VersionManagement />
                  </RoleProtectedRoute>
                } />
                <Route path="/whiteboard" element={
                  <RoleProtectedRoute pageName="whiteboard">
                    <Whiteboard />
                  </RoleProtectedRoute>
                } />
                <Route path="/login" element={<Navigate to="/" />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/request-account-deletion" element={<AccountDeletionRequestPage />} />
              </Routes>
            </div>
          </Content>
        </Layout>
      </Layout>
    </Router>
  );
};

const App = () => {
  return <MainApp />;
};

export default App;
